import {
    FaArrowLeft,
    FaEnvelope,
    FaPhone,
    FaGraduationCap,
    FaBriefcase,
    FaFilePdf,
    FaUserTie,
    FaDownload,
} from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";

const applicants = [
    {
        id: 1,
        name: "Wisdom Okposin",
        email: "wisdom@gmail.com",
        phone: "+234 801 234 5678",
        position: "Backend Developer",
        qualification: "B.Eng Electrical Engineering",
        experience: "3 Years",
        status: "New",
        applied: "15 July 2026",
        coverLetter:
            "I am passionate about software engineering and have experience building scalable web applications using React, Node.js and TypeScript.",
        cv: "wisdom_okposin_cv.pdf",
        skills: [
            "React",
            "Node.js",
            "TypeScript",
            "Express",
            "MySQL",
            "MongoDB",
        ],
    },
];

export default function ApplicantDetails() {
    // const { id } = useParams();
    const id = 1;
    const navigate = useNavigate();

    const applicant = applicants.find(
        (item) => item.id === Number(id)
    );

    if (!applicant)
        return (
            <div className="p-6">
                Applicant not found.
            </div>
        );

    return (
        <div className="p-6 max-w-6xl mx-auto">

            {/* Header */}

            <div className="flex items-center justify-between mb-8">

                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-gray-600 hover:text-blue-600"
                >
                    {FaArrowLeft({})}
                    Back
                </button>

                <select
                    defaultValue={applicant.status}
                    className="border rounded-lg px-4 py-2"
                >
                    <option>New</option>
                    <option>Reviewed</option>
                    <option>Shortlisted</option>
                    <option>Interview</option>
                    <option>Rejected</option>
                    <option>Hired</option>
                </select>

            </div>

            <div className="grid lg:grid-cols-3 gap-6">

                {/* Left */}

                <div className="bg-white rounded-xl border p-6">

                    <div className="flex flex-col items-center">

                        <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center">
                            {FaUserTie({
                                size: 40,
                                className: "text-blue-600"
                            })}
                        </div>

                        <h2 className="text-2xl font-bold mt-4">
                            {applicant.name}
                        </h2>

                        <p className="text-gray-500">
                            {applicant.position}
                        </p>

                    </div>

                    <div className="mt-8 space-y-5">

                        <div className="flex items-center gap-3">
                            {FaEnvelope ({ className: "text-blue-600" })}
                            <span>{applicant.email}</span>
                        </div>

                        <div className="flex items-center gap-3">
                            {FaPhone({ className: "text-blue-600" })}
                            <span>{applicant.phone}</span>
                        </div>

                        <div className="flex items-center gap-3">
                            {FaGraduationCap({ className: "text-blue-600" })}
                            <span>{applicant.qualification}</span>
                        </div>

                        <div className="flex items-center gap-3">
                            {FaBriefcase({ className: "text-blue-600" })}
                            <span>{applicant.experience}</span>
                        </div>

                    </div>

                </div>

                {/* Right */}

                <div className="lg:col-span-2 space-y-6">

                    <div className="bg-white rounded-xl border p-6">

                        <h3 className="font-semibold text-lg mb-3">
                            Cover Letter
                        </h3>

                        <p className="leading-7 text-gray-600">
                            {applicant.coverLetter}
                        </p>

                    </div>

                    <div className="bg-white rounded-xl border p-6">

                        <h3 className="font-semibold text-lg mb-4">
                            Skills
                        </h3>

                        <div className="flex flex-wrap gap-2">

                            {applicant.skills.map((skill) => (
                                <span
                                    key={skill}
                                    className="bg-blue-50 text-blue-700 px-3 py-2 rounded-full text-sm"
                                >
                                    {skill}
                                </span>
                            ))}

                        </div>

                    </div>

                    <div className="bg-white rounded-xl border p-6">

                        <h3 className="font-semibold text-lg mb-4">
                            Resume
                        </h3>

                        <div className="flex justify-between items-center border rounded-lg p-4">

                            <div className="flex items-center gap-3">
                                <span className="text-red-500 text-2xl" >{FaFilePdf({})}</span>

                                <div>

                                    <p className="font-medium">
                                        {applicant.cv}
                                    </p>

                                    <p className="text-sm text-gray-500">
                                        PDF Document
                                    </p>

                                </div>

                            </div>

                            <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2">
                                {FaDownload({})}
                                Download
                            </button>

                        </div>

                    </div>

                    <div className="bg-white rounded-xl border p-6">

                        <h3 className="font-semibold text-lg mb-3">
                            HR Notes
                        </h3>

                        <textarea
                            rows={5}
                            placeholder="Write notes..."
                            className="w-full rounded-lg border p-4 resize-none outline-none focus:border-blue-500"
                        />

                    </div>

                    <div className="flex flex-wrap gap-3">

                        <button className="bg-green-600 text-white px-5 py-3 rounded-lg">
                            Shortlist
                        </button>

                        <button className="bg-yellow-500 text-white px-5 py-3 rounded-lg">
                            Schedule Interview
                        </button>

                        <button className="bg-red-600 text-white px-5 py-3 rounded-lg">
                            Reject
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
}